import { theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const assistantHighlightStyles = css `
  .pl-assistant--selection {
    color: ${theme.swatches.blue[600]};
    background-color: ${theme.swatches.blue[100]};
  }
`;
